import { useEffect, useMemo, useState } from 'react';
import { getFallbackCount, syncSharedVisitCount } from '../lib/siteVisitCounter.js';

const footerActions = [
  { label: 'Email', href: 'mailto:ashwinisaxena6@gmail.com', icon: 'email' },
  { label: 'Telegram', href: 'https://t.me/+38OmasDPMBU0Yjhl', icon: 'telegram' },
  { label: 'WhatsApp', href: 'https://wa.me/917277410920', icon: 'whatsapp' },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/_ashwinii.i_?igsh=MThrNzhzMGR2NTNrbA==',
    icon: 'instagram',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/ashwini-saxena/',
    icon: 'linkedin',
  },
];

const brandHoverClasses = {
  Email: 'hover:bg-blue-50 hover:text-blue-600 hover:border-blue-300 dark:hover:bg-blue-950/30 dark:hover:text-blue-400 dark:hover:border-blue-800',
  Telegram: 'hover:bg-sky-50 hover:text-sky-600 hover:border-sky-300 dark:hover:bg-sky-950/30 dark:hover:text-sky-400 dark:hover:border-sky-800',
  WhatsApp: 'hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-300 dark:hover:bg-emerald-950/30 dark:hover:text-emerald-400 dark:hover:border-emerald-800',
  Instagram: 'hover:bg-pink-50 hover:text-pink-600 hover:border-pink-300 dark:hover:bg-pink-950/30 dark:hover:text-pink-400 dark:hover:border-pink-800',
  LinkedIn: 'hover:bg-blue-50 hover:text-blue-700 hover:border-blue-300 dark:hover:bg-blue-950/30 dark:hover:text-blue-400 dark:hover:border-blue-800',
};

const ActionIcon = ({ type }) => {
  switch (type) {
    case 'email':
      return (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
          <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm0 2v.2l8 5.4 8-5.4V7H4Zm16 10V9.6l-7.4 5a1 1 0 0 1-1.2 0L4 9.6V17h16Z" />
        </svg>
      );
    case 'telegram':
      return (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
          <path d="M21.5 4.5 18.4 19c-.2 1-.8 1.3-1.6.8l-4.6-3.4-2.2 2.1c-.2.3-.5.5-1 .5l.4-4.7 8.6-7.8c.4-.4-.1-.6-.6-.3l-10.7 6.8-4.6-1.4c-1-.3-1-.9.2-1.4l17.8-6.9c.8-.3 1.5.2 1.2 1.2Z" />
        </svg>
      );
    case 'whatsapp':
      return (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
          <path d="M20 11.9c0 4.5-3.7 8.1-8.2 8.1-1.4 0-2.8-.4-4-.9L3 20.5l1.5-4.5c-.8-1.3-1.2-2.7-1.2-4.1C3.3 7.4 7 3.8 11.5 3.8S20 7.4 20 11.9Zm-4.8 2.2-.7-.3c-.2-.1-.4-.1-.6.1l-.4.5c-.1.1-.3.2-.5.1-1-.4-2.4-1.6-2.9-2.6-.1-.2-.1-.4.1-.5l.4-.4c.2-.2.2-.4.1-.6l-.3-.7c-.1-.2-.2-.5-.5-.5h-.6c-.2 0-.4.1-.5.3-.5.6-.7 1.3-.6 2 .2 1.3 1 2.6 2.1 3.6 1 1 2.4 1.8 3.7 1.9.8.1 1.5-.2 2-.8.2-.2.3-.5.3-.8v-.4c0-.2-.1-.4-.4-.5Z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
          <path d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm0 2C5.9 5 5 5.9 5 7v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H7Zm5 2.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 0 1 12 7.5Zm0 2A2.5 2.5 0 1 0 14.5 12 2.5 2.5 0 0 0 12 9.5Zm4.8-3.1a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.1Z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
          <rect width="4" height="12" x="2" y="9" />
          <circle cx="4" cy="4" r="2" />
        </svg>
      );
    case 'about':
      return (
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" />
          <path d="M4 20a8 8 0 0 1 16 0" />
        </svg>
      );
    default:
      return null;
  }
};

const SiteFooter = ({ onNavigate }) => {
  const [now, setNow] = useState(() => new Date());
  const [visitCount, setVisitCount] = useState(() => getFallbackCount());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    let mounted = true;

    syncSharedVisitCount().then((count) => {
      if (mounted && Number.isFinite(count) && count > 0) {
        setVisitCount(count);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  const footerMeta = useMemo(() => {
    const date = now.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
    const time = now.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    return { date, time };
  }, [now]);

  return (
    <footer className="mt-8 border-t border-slate-200/80 bg-slate-50 dark:border-slate-900 dark:bg-[#030b1c]">
      <div className="w-full px-3.5 pt-5 pb-[calc(4.25rem+env(safe-area-inset-bottom,0px))] sm:px-6 sm:py-6 lg:px-8">
        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_10px_35px_rgba(15,23,42,0.08)] dark:border-[#1e355f] dark:bg-[#06142b] dark:shadow-[0_18px_40px_rgba(2,8,23,0.55)]">
          <div className="border-b border-slate-200 px-5 py-5 dark:border-[#203a63]">
            <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
              <div className="flex items-center gap-3">
                <span className="h-14 w-14 shrink-0 sm:h-16 sm:w-16">
                  <img
                    src="/campusguide-logo.webp"
                    alt="CampusGuide by Ashwini logo"
                    width="64"
                    height="64"
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-contain"
                  />
                </span>
                <span className="block h-10 w-[12.5rem] sm:h-12 sm:w-[14.8rem]">
                  <img
                    src="/campusguide-wordmark-clean.webp"
                    alt="CampusGuide by Ashwini"
                    width="240"
                    height="48"
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-contain object-left"
                  />
                </span>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                {footerActions.map((link) => {
                  const hoverClass = brandHoverClasses[link.label] || 'hover:bg-slate-100 hover:text-slate-950 hover:border-slate-300';
                  return (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                      className={`inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition-all duration-300 hover:-translate-y-1 hover:shadow-md dark:border-[#29466f] dark:text-white ${hoverClass}`}
                      aria-label={link.label}
                      title={link.label}
                    >
                      <ActionIcon type={link.icon} />
                    </a>
                  );
                })}
                <a
                  href="#/about"
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate('/about');
                  }}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:bg-slate-100 hover:text-slate-950 hover:border-slate-300 dark:border-[#29466f] dark:text-white dark:hover:bg-slate-800 dark:hover:border-slate-700"
                  aria-label="About"
                  title="About"
                >
                  <ActionIcon type="about" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-b border-slate-200 px-5 py-5 dark:border-[#203a63]">
            <div className="grid gap-3 sm:grid-cols-3">
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 dark:border-[#203a63] dark:bg-[#0d1b34]">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
                  Date
                </p>
                <p className="mt-2 text-sm font-semibold text-slate-900 dark:text-white">
                  {footerMeta.date}
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 dark:border-[#203a63] dark:bg-[#0d1b34]">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
                  Time
                </p>
                <p className="mt-2 text-sm font-semibold text-slate-900 dark:text-white">
                  {footerMeta.time}
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 dark:border-[#203a63] dark:bg-[#0d1b34]">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
                  Visitors
                </p>
                <p className="mt-2 text-sm font-semibold text-slate-900 dark:text-white">
                  {visitCount.toLocaleString('en-IN')}
                </p>
              </div>
            </div>
          </div>

          <div className="px-4 py-3.5 sm:px-5 sm:py-4">
            <div className="flex flex-col gap-2 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
              <p className="text-sm text-slate-500 dark:text-slate-400">
                © 2026 CampusGuide by Ashwini. All rights reserved.
              </p>

              <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:justify-end">
                <a
                  href="#/terms-and-conditions"
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate('/terms-and-conditions');
                  }}
                  className="text-sm font-medium text-slate-600 transition hover:text-emerald-700 dark:text-slate-300 dark:hover:text-emerald-300"
                >
                  Terms & Conditions
                </a>
                <a
                  href="#/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate('/privacy-policy');
                  }}
                  className="text-sm font-medium text-slate-600 transition hover:text-emerald-700 dark:text-slate-300 dark:hover:text-emerald-300"
                >
                  Privacy Policy
                </a>
                <span className="text-sm text-slate-500 dark:text-slate-400">
                  Made with 🩵 by Ashwini
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
